var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.294,
    height: 42.294,
    viewBox: "0 0 42.294 42.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}.b{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.988 -0.988)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M206.06,6.2H222.1a1.459,1.459,0,0,1,1.459,1.459V23.7a1.459,1.459,0,0,1-1.459,1.458H206.06A1.458,1.458,0,0,1,204.6,23.7V7.658A1.458,1.458,0,0,1,206.06,6.2Zm0,0",
    transform: "translate(-180.279 -5.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.658,6.2H23.7a1.459,1.459,0,0,1,1.458,1.459V23.7A1.458,1.458,0,0,1,23.7,25.158H7.658A1.459,1.459,0,0,1,6.2,23.7V7.658A1.458,1.458,0,0,1,7.658,6.2Zm0,0",
    transform: "translate(-5.211 -5.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.658,204.6H23.7a1.458,1.458,0,0,1,1.458,1.458V222.1a1.459,1.459,0,0,1-1.458,1.459H7.658A1.459,1.459,0,0,1,6.2,222.1V206.06A1.458,1.458,0,0,1,7.658,204.6Zm0,0",
    transform: "translate(-5.211 -180.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.658,204.6H23.7a1.458,1.458,0,0,1,1.458,1.458V222.1a1.459,1.459,0,0,1-1.458,1.459H7.658A1.459,1.459,0,0,1,6.2,222.1V206.06A1.458,1.458,0,0,1,7.658,204.6Zm0,0",
    transform: "translate(17.789 -180.279)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.4d62333f9f97f5e0fa52a121ff83d01c.svg";
export { ForwardRef as ReactComponent };